<div *ngIf="!upload">
  <app-countries-filter
    (search)="searchCountries($event)">
  </app-countries-filter>
  <mat-divider></mat-divider>
  <app-countries-table *ngIf="countries"
    [countries]="countries.content"
    [page]="countries.number"
    [pageSize]="countries.size"
    [totalElements]="countries.totalElements"
    (loadCountries)="loadCountries($event)"
    (updateCountryStatus)="updateCountryStatus($event)"
    (deleteCountry)="deleteCountry($event)">
  </app-countries-table>
</div>
<div *ngIf="upload">
  <app-upload-population></app-upload-population>
</div>
